import React from "react";
import './Loading.css';

const Loading = () => {
  return (
    <div className="loader-wrapper">
      <h2>Loading</h2>
      <div className="loader"></div>
    </div>
  );
};

export default Loading;